const XLSX = require('xlsx-color');
//const fs = require('fs');
const path = require('path');

function generateWildlifeReport(data) {

     // Extract yearStart, yearEnd, and reportData from data object
     const { yearStart, yearEnd, reportData} = data;

    // Map the data received from the API to match Excel columns
    const formattedData = reportData.map(sighting => ({
        'Name of Company': sighting.nameOfCompany,
        'Tenure Number': sighting.tenureNumber,
        'Heliski Zone': sighting.heliskiZone,
        'Date': sighting.date,
        'Surveyor Name': sighting.surveyorName,
        'Species': sighting.species,
        'Animal Count': sighting.animalCount,
        'UTM Zone': sighting.utmZone,
        'Coordinates': sighting.coordinates,
        'UTM N': sighting.utmN,
        'Comments': sighting.comments,
        'Animal Distance': sighting.animalDistance,
        'Aspect of Animal': sighting.aspectOfAnimal,
        'Elevation': sighting.elevation,
        'Animal Reaction': sighting.animalReaction,
        'Immediate Action': sighting.immediateAction,
        'End of Day Action': sighting.endOfDayAction,
        'Inventory Method': sighting.inventoryMethod,
        'Ski Run': sighting.skiRun,
        'Number of Animal Tracks': sighting.numberOfAnimalTracks,
        'Type of Machine': sighting.typeOfMachine,
        'Snowmobile Observed': sighting.snowmobileObserved,
        'Snowmobile Track Observed': sighting.snowmobileTrackObserved
    }));

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data array to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Define header style
    const headerStyle = {
        fill: {
            patternType: 'solid',
            fgColor: { rgb: 'CCCCCC' } // Gray background color
        },
        font: {
            color: { rgb: '000000' }, // Black font color
            bold: true // Bold font weight
        }
    };

    // Apply header style to the first row (headers)
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
        const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: col });
        if (worksheet[headerCell]) {
            worksheet[headerCell].s = headerStyle;
        }
    }

    // Apply auto filter to all columns
    worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) };

    // Add the worksheet to the workbook under the name 'Wildlife Report'
    // Note: Sheet names cannot exceed 31 characters, so keeping it simple
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Wildlife Report');

    // Generate a file path for the Excel file
    //const today = new Date();
    //const dateString = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    const filePath = path.join(__dirname, `Wildlife-Report-${yearStart}to${yearEnd}.xlsx`);

    // Write the workbook to a file
    XLSX.writeFile(workbook, filePath);

    //console.log(`Excel file generated at: ${filePath}`);

    return filePath;
}

module.exports = generateWildlifeReport;
